"use client";

import dynamic from "next/dynamic";
import type { VoiceIsolatorV2Props } from "./VoiceIsolatorV2";

const VoiceIsolatorV2 = dynamic(() => import("./VoiceIsolatorV2"));

export default function VoiceIsolatorV2Lazy(props: VoiceIsolatorV2Props) {
  return <VoiceIsolatorV2 {...props} />;
}
